export const colorsBg = {
  white: 'bg-white text-black',
  light: 'bg-gray-100 text-black',
  success: 'bg-green-500 text-white',
  danger: 'bg-red-500 text-white',
  warning: 'bg-yellow-500 text-white',
  info: 'bg-blue-500 text-white',
  gray: 'bg-gray-500 text-white',
  orange: 'bg-orange-500 text-white',
  purple: 'bg-purple-500 text-white',
  pink: 'bg-pink-500 text-white',
  indigo: 'bg-indigo-500 text-white',
  teal: 'bg-teal-500 text-white'
}

export const colorsBgHover = {
  white: 'hover:bg-gray-50',
  light: 'hover:bg-gray-200',
  success: 'hover:bg-green-600',
  danger: 'hover:bg-red-600',
  warning: 'hover:bg-yellow-600',
  info: 'hover:bg-blue-600',
  gray: 'hover:bg-gray-600',
  orange: 'hover:bg-orange-600',
  purple: 'hover:bg-purple-600',
  pink: 'hover:bg-pink-600',
  indigo: 'hover:bg-indigo-600',
  teal: 'hover:bg-teal-600'
}

export const colorsBorders = {
  white: 'border-gray-300',
  light: 'border-gray-200 dark:border-gray-400',
  success: 'border-green-600',
  danger: 'border-red-600',
  warning: 'border-yellow-600',
  info: 'border-blue-600',
  gray: 'border-gray-600',
  orange: 'border-orange-600',
  purple: 'border-purple-600',
  pink: 'border-pink-600',
  indigo: 'border-indigo-600',
  teal: 'border-teal-600'
}

export const colorsText = {
  white: 'text-black dark:text-gray-100',
  light: 'text-gray-500 dark:text-gray-400',
  success: 'text-green-500',
  litesuccess: 'text-green-400',
  darksuccess: 'text-green-800',
  danger: 'text-red-500',
  warning: 'text-yellow-500',
  info: 'text-blue-500',
  sky: 'text-sky-500',
  rose: 'text-rose-500',
}

export const colorsOutline = {
  white: [colorsText.white, colorsBorders.white],
  light: [colorsText.light, colorsBorders.light],
  success: [colorsText.success, colorsBorders.success],
  danger: [colorsText.danger, colorsBorders.danger],
  warning: [colorsText.warning, colorsBorders.warning],
  info: [colorsText.info, colorsBorders.info]
}

export const colorsOutlineHover = {
  white: 'hover:bg-gray-100 hover:text-gray-900 dark:hover:text-gray-900',
  light: 'hover:bg-gray-100 hover:text-gray-900 dark:hover:text-gray-900',
  success: 'hover:bg-green-500 hover:text-white',
  danger: 'hover:bg-red-500 hover:text-white',
  warning: 'hover:bg-yellow-500 hover:text-white',
  info: 'hover:bg-blue-500 hover:text-white'
}

export const getButtonColor = (color, isOutlined, hasHover) => {
  const base = [
    isOutlined ? colorsText[color] : colorsBg[color],
    colorsBorders[color]
  ]

  if (hasHover) {
    base.push(isOutlined ? colorsOutlineHover[color] : colorsBgHover[color])
  }

  return base
}
